@if (!result) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (result) {
  <ng-container [formGroup]="form">
    <section #top>
      @if(forceDialog || showDownload) {
        <dialog-hint clickTarget="next-steps" class="pdf-hint" [textkey]="textkeyPrefix + '.callout.' + anfrage.interesse"
        [closable]="true"></dialog-hint>
      }
    </section>
    <h1 [innerHTML]="textkeyPrefix + '.headline' | translate"></h1>
    <section>
      <div class="callout lighter-gray teaser">
        <p [innerHTML]="textkeyPrefix + '.teaser' + headlinePostfix + (anfrage.interesse === INTERESSE_BALKON? '.balkon' : '') | translate"></p>
        <div class="grid-x grid-padding-x align-center">
          <div class="cell medium-shrink">
            <app-advisor-image [path]="'/pvc/icon-gebaeude_dachform_' + anfrage.userInput.aufstellort + '.svg'"></app-advisor-image>
            <span>
              @if(['freiflaeche', 'balkon'].includes(anfrage.userInput.aufstellort)) {
                {{ 'photovoltaikcheck.aufstellort.' + anfrage.userInput.aufstellort + '.label.short' | translate }}<br>
              }
              @else {
              {{ 'photovoltaikcheck.aufstellort.' + anfrage.userInput.aufstellort + '.label' | translate }}
            }
            <br>
              @if(anfrage.userInput.dachneigung) {
                <span>{{ anfrage.userInput.dachneigung }} °</span>
              }
            </span>
          </div>
          @if(anfrage.interesse === INTERESSE_PV) {
            <div class="cell medium-shrink">
              <app-advisor-image [path]="'/pvc/pvc_flaeche.svg'"></app-advisor-image>
              <span>
                {{ textkeyPrefix + '.teaser.area' | translate }}<br>
                {{ anfrage.userInput.flaeche_verfuegbar | number: '1.0-0' }} m²
              </span>
            </div>
          }
          @if(anfrage.userInput.himmelsausrichtung !== null && anfrage.userInput.aufstellort !== 'freiflaeche') {
            <div class="cell medium-shrink">
              <app-advisor-image [path]="'/pvc/pvc_himmelsausrichtung.svg'"></app-advisor-image>
              <span>
                {{ textkeyPrefix + '.teaser.roof' | translate }}<br>
                {{ ('photovoltaikcheck.himmelsausrichtung.' + anfrage.userInput.himmelsausrichtung_direction) | translate }}
              </span>
            </div>
          }
        </div>
      </div>
    </section>
    @if(anfrage.interesse === INTERESSE_PV) {
      <section class="solaranlage-wrapper" [class.internal]="internalPortal" [class.loading]="loading" #devices>
        <h2 [innerHTML]="textkeyPrefix + '.anlage.headline' + headlinePostfix | translate"></h2>
        <div class="flip-container flip-horizontal" [class.open]="toggle.compare" [style.height.px]="minHeightCompare">
          <div class="flipper">
            <div id="card-front" class="card front" #frontCardCompare [attr.aria-hidden]="toggle.compare">
              <div class="configuration-selection grid-x align-center">
                @if(ownUseConfigurations[0]) {
                  <div class="cell small-6 medium-4">
                    <button class="button tab-nav" [tabIndex]="toggle.compare? '-1' : '0'" [attr.aria-expanded]="currentConfigurationType !== OPTIMIERUNG_VOLLEINSPEISUNG" aria-controls="callout-1 callout-2 callout-3 callout-4" (click)="setSelection(ownUseConfigurations[0])" [class.primary]="currentConfigurationType !== OPTIMIERUNG_VOLLEINSPEISUNG" [innerHTML]="textkeyPrefix + '.anlage.label.eigennutzung' | translate"></button>
                  </div>
                }
                @if (hasFeedinConfiguration) {
                  @if (hasFeedinConfiguration) {
                    <div class="cell small-6 medium-4">
                      <button class="button tab-nav" [tabIndex]="toggle.compare? '-1' : '0'" (click)="setSelection('volleinspeisung')" [class.primary]="currentConfigurationType === OPTIMIERUNG_VOLLEINSPEISUNG" [innerHTML]="textkeyPrefix + '.anlage.label.volleinspeisung' | translate"></button>
                    </div>
                  }
                }
              </div>
              @if (currentConfigurationType !== OPTIMIERUNG_VOLLEINSPEISUNG) {
                <div id="callout-1" class="callout">
                  <h3 [innerHTML]="textkeyPrefix + '.anlage.subheadline' | translate"></h3>
                  <div class="grid-x align-center selection-wrapper">
                    <div class="cell small-12 medium-auto selection">
                      @for (configuration of ownUseConfigurations; track configuration) {
                        <button type="button" role="radio" [tabIndex]="toggle.compare? '-1' : '0'" [attr.aria-expanded]="" aria-controls="callout-3" [class.right]="$first" [class.active]="currentConfigurationType.startsWith(configuration)" [value]="configuration" (click)="setSelection(configuration)">
                          <span>{{(textkeyPrefix + '.anlage.label.' + configuration.replace(OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG, '')) | translate}}</span>
                        </button>
                      }
                    </div>
                    <div class="cell small-12 medium-shrink" [innerHTML]="textkeyPrefix + '.anlage.or' | translate"></div>
                    <div class="cell small-12 medium-shrink selection">
                      <button type="button" role="radio" [tabIndex]="toggle.compare? '-1' : '0'" [attr.aria-expanded]="" aria-controls="callout-3" [class.active]="currentConfigurationType === OPTIMIERUNG_INDIVIDUELL" [value]="OPTIMIERUNG_INDIVIDUELL" (click)="setSelection(OPTIMIERUNG_INDIVIDUELL)">
                        <span>{{ textkeyPrefix + '.anlage.label.' + OPTIMIERUNG_INDIVIDUELL | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              }
              @if(hasVolleinspeisung) {
                <div id="callout-2" class="callout toggle-wrapper">
                  <div class="toggle invert">
                    <input type="checkbox" id="volleinspeisung" formControlName="volleinspeisung">
                    <label for="volleinspeisung" [innerHTML]="textkeyPrefix + '.anlage.toggle.volleinspeisung' | translate"></label>
                  </div>
                  <button type="button" [tabIndex]="toggle.compare? '-1' : '0'" class="help-button" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggle.feedinHelp = !toggle.feedinHelp"><i class="icon-help-circle"></i></button>
                </div>
                @if(toggle.feedinHelp) {
                  <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="anlage.volleinspeisung" (close)="toggle.feedinHelp = !toggle.feedinHelp"></app-photovoltaikcheck-ergebnis-help>
                }
              }
              <div id="callout-3" aria-live="polite" class="callout" [class.helpoverlay]="toggle.glossary || toggle.deviceChange" #resultScrollTarget>
                <div class="grid-x grid-padding-x">
                  <div class="cell small-12 medium-6">
                    <p [innerHTML]="textkeyPrefix + '.fazit.' + result.result.ratings.summary[currentConfigurationType] | translate: placeholder"></p>
                    @if(anfrage.userInput.aufstellort === 'flachdach') {
                      <p [innerHTML]="textkeyPrefix + '.fazit.flachdach' | translate: placeholder"></p>
                    }
                    @if(anfrage.userInput.gebaeudetyp !== 'mehrfamilienhaus' && result.result.data.photovoltaic_systems.length === 1) {
                      <p [innerHTML]="textkeyPrefix + '.fazit.verbrauchgering' | translate: placeholder"></p>
                    }
                  </div>
                  <div class="cell small-12 medium-6">
                    <app-photovoltaikcheck-ergebnis-image-solar
                      [result]="result"
                      [currentConfigurationType]="currentConfigurationType"
                      [internalPortal]="internalPortal"
                      (areaChanged)="recalculateAreas($event)"
                      [isHidden]="toggle.compare"
                    ></app-photovoltaikcheck-ergebnis-image-solar>
                    <div class="infotext-wrapper text-right">
                      <button type="button" [attr.aria-expanded]="toggle.glossary" aria-controls="info-glossary" [attr.aria-label]="'arialabel.toggle.info' | translate" (click)="toggleGlossary()" class="infocallout-button"><i class="icon-info"></i> <span [innerHTML]="textkeyPrefix + '.glossary.label' | translate"></span></button>
                      @if (toggle.glossary) {
                        <div id="info-glossary" class="callout infocallout">
                          <button class="close" type="button" [attr.aria-label]="'arialabel.close' | translate" (click)="toggleGlossary()"><i class="icon-x"></i></button>
                          <p [innerHTML]="textkeyPrefix + '.glossary.text' | translate"></p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                @if(result.result.data.photovoltaic_systems.length > 1) {
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-12">
                      <button class="button primary hollow inline-arrow-right" [attr.aria-expanded]="toggle.compare" aria-controls="card-back" [innerHTML]="textkeyPrefix + '.vergleich.button' | translate" (click)="flipCompare()"></button>
                    </div>
                  </div>
                }
                @if (toggle.deviceChange) {
                  <div id="callout-4" class="callout changecallout" role="dialog" [attr.aria-modal]="toggle.deviceChange" aria-live="polite">
                    <button class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="toggle.deviceChange = !toggle.deviceChange"><i class="icon-x"></i></button>
                    <p [innerHTML]="textkeyPrefix + '.aenderung.hinweis' | translate"></p>
                    <button  class="button primary inline-arrow-right" (click)="toggle.deviceChange = !toggle.deviceChange" [innerHTML]="textkeyPrefix + '.aenderung.button' | translate" #creditOverlayButton></button>
                  </div>
                }
              </div>
            </div>
            <div id="card-back" class="card back overflow" #backCardCompare [attr.aria-hidden]="!toggle.compare">
              <div class="text-right">
                <button [attr.aria-expanded]="!toggle.compare" [tabindex]="!toggle.compare? -1 : ''" aria-controls="card-front" class="button round primary small compare-close" (click)="flipCompare()" >
                  <i class="icon-x" [title]="textkeyPrefix + '.vergleich.close' | translate"></i>
                  {{ textkeyPrefix + '.vergleich.close' | translate }}
                </button>
              </div>
              <app-photovoltaikcheck-ergebnis-compare
                [textkeyPrefix]="textkeyPrefix"
                [result]="result"
                [currentConfigurationType]="currentConfigurationType"
                [configurationTypes]="compareConfigurations"
                [anfrage]="anfrage"
                (heightChange)="updateHeights()"
                [isHidden]="!toggle.compare"
              ></app-photovoltaikcheck-ergebnis-compare>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h2 [innerHTML]="textkeyPrefix + '.finanzierung.headline' | translate"></h2>
        <p [innerHTML]="textkeyPrefix + '.finanzierung.teaser' | translate"></p>
      </section>
      <section #invest>
        <div class="finance-wrapper" [class.loading]="loading">
          <div class="invest-header">
            <h3 [innerHTML]="textkeyPrefix + '.finanzierung.invest' | translate"></h3>
            <div class="toggle">
              <input type="checkbox" id="invest-credit" formControlName="credit" [checked]="hasCredit" [attr.aria-expanded]="toggle.deviceChange" aria-controls="callout-4">
              <label for="invest-credit" [innerHTML]="textkeyPrefix + '.finanzierung.credit.label' + (hasCredit? '.active' : '') | translate"></label>
            </div>
            <div>
              <span class="amount">{{ configuration.finanzierung.investitionskosten_gesamt | number: '1.0-0' }} €</span>
              <button class="help-button" [attr.aria-label]="'arialabel.toggle.help' | translate" [title]="textkeyPrefix + '.hilfe' | translate" (click)="toggle.investHelp = !toggle.investHelp"><i class="icon-help-circle"></i></button>
            </div>
          </div>
          @if (toggle.investHelp) {
            <app-photovoltaikcheck-ergebnis-help [textkeyprefix]="textkeyPrefix" topic="finanzierung.invest" (close)="toggle.investHelp = !toggle.investHelp"></app-photovoltaikcheck-ergebnis-help>
          }
          <div class="invest-content">
            @if (hasCredit) {
              @if(false) {
                <div class="grid-x grid-padding-x">
                  <div class="cell auto" [innerHTML]=" textkeyPrefix + '.finanzierung.credit.teaser' | translate"></div>
                </div>
                <hr>
                  <div class="grid-x grid-padding-x equity" >
                    <div class="cell small-8 medium-4">
                      <span class="label" [innerHTML]="textkeyPrefix + '.finanzierung.label' | translate"></span>
                    </div>
                    <div class="cell small-12 medium-5 slider-wrapper">
                      <mat-slider class="round-knob" [step]="500" [min]="sliderMin" [max]="sliderMax" [displayWith]="formatSliderLabel" [discrete]="true">
                        <input matSliderThumb [value]="anfrage.userInput.eigenkapital" (valueChange)="toggle.calculationNeeded = true" formControlName="eigenkapital">
                      </mat-slider>
                    </div>
                    <div class="cell small-12 medium-3 text-right">
                      <button class="button primary medium" [class.attention]="toggle.calculationNeeded" [innerHTML]="textkeyPrefix + '.finanzierung.button' | translate" (click)="reCalculate()"></button>
                      @if(toggle.calculationNeeded) {
                        <button class="button primary hollow medium" [innerHTML]="textkeyPrefix + '.finanzierung.button.reset' | translate" (click)="resetRecalculation()"></button>
                      }
                    </div>
                  </div>
                  <hr>
                  }
                }
                <div class="grid-x grid-padding-x">
                  @if (configuration.finanzierung?.foerderung_zuschuss?.summe > 0) {
                    @for(zuschuss of configuration.finanzierung.foerderung_zuschuss.details; track zuschuss.name) {
                      <div class="cell auto">
                        {{ textkeyPrefix + '.finanzierung.zuschuss' | translate }}
                        <br>
                          {{ zuschuss.name }}
                        </div>
                        <div class="cell auto text-right">
                          {{ zuschuss.wert | number: '1.0-0' }} €
                        </div>
                      }
                    }
                    @else {
                    <div class="cell auto">{{ textkeyPrefix + '.finanzierung.keinzuschuss' | translate }}</div>
                  }
                </div>
                @if (configuration.finanzierung?.foerderung_zuschuss?.summe > 0 && !hasCredit) {
                  <hr>
                    <div class="grid-x grid-padding-x">
                      <div class="cell auto">
                        {{ textkeyPrefix + '.finanzierung.investition' | translate }}
                      </div>
                      <div class="cell auto text-right">
                        {{ (configuration.finanzierung.investitionskosten_gesamt - configuration.finanzierung?.foerderung_zuschuss?.summe) | number: '1.0-0' }} €
                      </div>
                    </div>
                  }
                  @if(hasCredit) {
                    @for(kredit of configuration.finanzierung?.foerderung_kredit?.details; track kredit) {
                      <hr>
                        <div class="grid-x grid-padding-x">
                          <div class="cell auto">
                            {{ textkeyPrefix + '.finanzierung.kredit' | translate }}<br>
                            {{ kredit.name }}
                          </div>
                          <div class="cell auto text-right">
                            {{ kredit.wert | number: '1.0-0' }} €
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </section>
              <section class="economics">
                <h2 [innerHTML]="textkeyPrefix + '.wirtschaftlichkeit.headline' | translate"></h2>
                <app-photovoltaikcheck-ergebnis-cost
                  [placeholder]="placeholder"
                  [ratings]="ratings"
                  [textkeyPrefix]="textkeyPrefix"
                  [anfrage]="anfrage"
                  (resultChanged)="onResultUpdatePv()">
                </app-photovoltaikcheck-ergebnis-cost>
              </section>
              <section>
                <h2 [innerHTML]="textkeyPrefix + '.klima.headline' | translate"></h2>
                <div class="grid-x grid-padding-x">
                  @for (type of ['jaehrlich', 'ausgleich_baeume']; track type) {
                    <div class="cell small-6">
                      <div class="co2">
                        <span [innerHTML]="textkeyPrefix + '.klima.' + type | translate"></span>
                        <strong>{{ placeholder['co2_' + type] }}
                          @if (type !== 'ausgleich_baeume') {
                            t
                          }
                        </strong>
                      </div>
                    </div>
                  }
                  <div class="cell small-12 medium-text-right">
                    <small class="hint" [innerHTML]="textkeyPrefix + '.klima.hint' | translate: placeholder"></small>
                  </div>
                </div>
              </section>
            }
            @if(anfrage.interesse === INTERESSE_BALKON) {
              <section [class.internal]="internalPortal">
                <app-photovoltaikcheck-ergebnis-balcony [textkeyPrefix]="textkeyPrefix" [anfrage]="anfrage"></app-photovoltaikcheck-ergebnis-balcony>
              </section>
            }
            @if(forceDialog || showDownload) {
              <section id="next-steps">
                <div class="grid-x grid-margin-x">
                  <div class="cell small-12 medium-7">
                    <div class="nextsteps-wrapper" [class.internal]="internalPortal">
                      <h2 [innerHTML]="textkeyPrefix + '.nextsteps.headline' | translate"></h2>
                      <p [innerHTML]="textkeyPrefix + '.nextsteps.teaser.' + anfrage.interesse | translate"></p>
                    </div>
                  </div>
                </div>
              </section>
            }
            @if(showDownload || forceDialog) {
              <section>
                @if (showDownload) {
                  <app-download [url]="reportUrl" [textkeyPrefix]="textkeyPrefix + '.'"></app-download>
                }
                @if (forceDialog) {
                  <app-dialogform textkeyPrefix="photovoltaikcheck" [textkeyPostfix]="anfrage.interesse === INTERESSE_BALKON? '.balkon' : ''" advisorImagePath="/pvc/pdf-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="reportUrl"></app-dialogform>
                }
              </section>
            }
            @if(faqTopics) {
              <section>
                <h2 [innerHTML]="textkeyPrefix + '.faq.headline' | translate"></h2>
                <app-faq [textkeyPrefix]="textkeyPrefix" [faqTopics]="faqTopics"></app-faq>
              </section>
            }
            <section>
              @if (advisorUrls.moc) {
                <app-advisor-teaser [url]="advisorUrls.moc" [mailUrl]="advisorUrls.moc" [textPrefix]="textkeyPrefix + '.teaser.moc'" image="/pvc/moc-teaser.svg"></app-advisor-teaser>
              }
              @if (advisorUrls.wpc) {
                <app-advisor-teaser [url]="advisorUrls.wpc" [mailUrl]="advisorUrls.wpc" [textPrefix]="textkeyPrefix + '.teaser.wpc'" image="/pvc/wpc-teaser.svg"></app-advisor-teaser>
              }
              @if (advisorUrls.stc) {
                <app-advisor-teaser [url]="advisorUrls.stc" [mailUrl]="advisorUrls.stc" [textPrefix]="textkeyPrefix + '.teaser.stc'" image="/pvc/stc-teaser.svg" changeColumnOrder="true"></app-advisor-teaser>
              }
            </section>
            @if (hasPortalTeaser) {
              <section>
                <app-portal-teaser></app-portal-teaser>
              </section>
            }
            @if (internalPortal) {
              <section>
                <app-donate textkeyPrefix="photovoltaikcheck"></app-donate>
              </section>
            }
          </ng-container>
        }

        @if (result) {
          <div class="grid-x grid-padding-x back-wrapper">
            <div class="cell">
              <app-step-buttons [previousLink]="previousLink"
                mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
              previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
            </div>
          </div>
        }

        @if(toggle.calculationNeeded) {
          <div class="calculationneeded-overlay top" [style.height.px]="calculationOverlay.top"></div>
          <div class="calculationneeded-overlay bottom" [style.height.px]="calculationOverlay.bottom"></div>
        }
